import { z } from "zod";

import { expressionTypeSchema } from "./enums";

export const assignmentExpressionSchema = z.object({
	id: z.string(),
	target: z.string(),
	valueExpression: z.string(),
	expressionType: expressionTypeSchema.optional(),
});
export type AssignmentExpression = z.infer<typeof assignmentExpressionSchema>;
